












import {Vue, Component, Prop} from "vue-property-decorator";
import ServiceService, {IService} from "./../services/service.service";
import MarkdownViewer from "@/components/ui/MarkdownViewer.vue";

@Component({
    components: {
        MarkdownViewer,
    }
})
export default class ServiceDisplay extends Vue {

    @Prop()
    public service!: IService;
}

